import {
 SHOW_MODAL, HIDE_MODAL, SET_MODAL_BUTTON_LOADING

} from '../constants';

export const showModal = (payload) => ({
  type: SHOW_MODAL,
  payload,
});

export const hideModal = () => ({
  type: HIDE_MODAL,
});

export const setModalButtonLoading = (btn) => ({
  type: SET_MODAL_BUTTON_LOADING,
  payload: btn, // "yes" | "no" | null
});